import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './FreeSpinLauncher.css';

export default function FreeSpinLauncher({ visible = true, label = 'Free Spin' }) {
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(false);

  if (!visible || hidden) return null;

  return (
    <button
      aria-label="Open Free Spin"
      className="fs-float-launcher"
      onClick={() => navigate('/free-spin')}
    >
      <span className="fs-float-emoji" role="img" aria-hidden>
        🎁
      </span>
      <span className="fs-float-text">{label}</span>
      <span
        className="fs-float-close"
        role="button"
        aria-label="Close launcher"
        onClick={(e) => { e.stopPropagation(); setHidden(true); }}
      >
        ×
      </span>
    </button>
  );
}
